import {
  AUTH_ROUTE_V2,
  DOWNLOAD_ROUTE_V2,
  EMAIL_CONFIRMATION_ROUTE_V2,
  PUBLIC_DOWNLOAD_ROUTE_V2,
  RESET_PASSWORD_CONFIRM_ROUTE_V2,
  RESET_PASSWORD_ROUTE_V2,
  SIGN_IN_ROUTE_V2,
  SIGN_UP_ROUTE_V2,
} from '@/router/routes';
import RootRoute from '@/v2/pages/RootRoute.vue';

const ResetPasswordPageV2 = () =>
  import('@/v2/pages/ResetPasswordPageV2.vue');
const SignInPageV2 = () => import('@/v2/pages/SignInPageV2.vue');
const SignUpPageV2 = () => import('@/v2/pages/SignUpPageV2.vue');
const DownloadPageV2 = () => import('@/v2/pages/DownloadPageV2.vue');
const PublicDownloadPageV2 = () => import('@/v2/pages/PublicDownloadPageV2.vue');
const AuthConfirmPageV2 = () => import('@/v2/pages/AuthConfirmPageV2.vue');
const EmailConfirmationPageV2 = () =>
  import('@/v2/pages/EmailConfirmationPageV2.vue');

export const v2RouterSegment = [
  {
    path: '/',
    component: RootRoute,
    children: [
      {
        path: '/v2/',
        name: SIGN_UP_ROUTE_V2.name,
        component: SignUpPageV2,
        meta: { amplitudeTitle: '[Web] Sign Up' },
      },
      {
        path: SIGN_UP_ROUTE_V2.path,
        name: SIGN_UP_ROUTE_V2.name,
        component: SignUpPageV2,
        meta: { amplitudeTitle: '[Web] Sign Up' },
      },
      {
        path: SIGN_IN_ROUTE_V2.path,
        name: SIGN_IN_ROUTE_V2.name,
        component: SignInPageV2,
        meta: { amplitudeTitle: '[Web] Sign In' },
      },
      {
        path: EMAIL_CONFIRMATION_ROUTE_V2.path,
        name: EMAIL_CONFIRMATION_ROUTE_V2.name,
        component: EmailConfirmationPageV2,
        meta: { amplitudeTitle: '[Web] Email Confirmation' },
      },
      {
        path: DOWNLOAD_ROUTE_V2.path,
        name: DOWNLOAD_ROUTE_V2.name,
        component: DownloadPageV2,
        meta: { requiresAuth: true, amplitudeTitle: '[Web] Download' },
      },
      {
        path: PUBLIC_DOWNLOAD_ROUTE_V2.path,
        name: PUBLIC_DOWNLOAD_ROUTE_V2.name,
        component: PublicDownloadPageV2,
        meta: { amplitudeTitle: '[Web] Download' },
      },
      {
        path: RESET_PASSWORD_ROUTE_V2.path,
        name: RESET_PASSWORD_ROUTE_V2.name,
        component: ResetPasswordPageV2,
        meta: { amplitudeTitle: '[Web] Reset Password' },
      },
      {
        path: RESET_PASSWORD_CONFIRM_ROUTE_V2.path,
        name: RESET_PASSWORD_CONFIRM_ROUTE_V2.name,
        component: ResetPasswordPageV2,
        props: true,
        meta: { amplitudeTitle: '[Web] Reset Password Confirm' },
      },
      {
        path: AUTH_ROUTE_V2.path,
        name: AUTH_ROUTE_V2.name,
        component: AuthConfirmPageV2,
      },
    ],
  },
];